import { useState, useEffect } from "react";
import {
    Container,
    CssBaseline,
    TextField,
    FormControlLabel,
    Checkbox,
    Grid,
    Typography,
    Card,
    CardContent
} from '@material-ui/core';
import { useStyles } from "./styles";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { login, logoutThunk } from "store/thunks/user";
import { showNotification } from "store/slices/snackbar/snackbarSlice";
import Button from '../../components/button';
import { Link } from "@mui/material";
import { getJWTToken } from "store/selectors/userSelector";

const Login = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const token = useSelector(getJWTToken);
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const verified = params.get('verified');

        if (verified) {
            setVerified(true);
        }
    }, [location.search]);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (validate()) {
            dispatch(login(username, password, history))
        }
    };

    const validate = (): boolean => {
        //Required Fields
        if (username === '' || password === '') {
            dispatch(showNotification({ message: "Please enter username and pasword", variant: "warning" }));
            return false;
        }
        return true;
    };
    const dispatchLogout = () => {
        dispatch(logoutThunk(token, history));
    }
    return (
        <Container component="main" className={classes.loginWrapper}>
            <CssBaseline />
            <Grid xs={4} className={classes.paper}>
                <Typography component="h1" variant="h5" className={classes.header}>
                    Log in
                </Typography>
                <form className={classes.form} noValidate onSubmit={handleSubmit}>
                    {verified ?
                        <Card className={classes.card}>
                            <CardContent className={classes.cardContent}>
                                <Typography component="p" className={classes.cardText}>Account verified!</Typography>
                            </CardContent>
                        </Card> : null
                    }
                    {token ?
                        <Card className={classes.card}>
                            <CardContent className={classes.cardContent}>
                                <Typography component="p" className={classes.cardText}>
                                    You are already logged in
                                    <Link onClick={() => dispatchLogout()} variant="body2" style={{ cursor: 'pointer' }}>
                                        &nbsp;Logout
                                    </Link>
                                </Typography>
                            </CardContent>
                        </Card> : <>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="emailAddress"
                                label="Email Address"
                                name="emailaddress"
                                autoComplete="emailAddress"
                                value={username}
                                onChange={(e) => { setUserName(e.target.value.trim()) }}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                value={password}
                                autoComplete="current-password"
                                onChange={(e) => { setPassword(e.target.value.trim()) }}
                            />
                            <Grid container>
                                <Grid item xs>
                                    <FormControlLabel
                                        control={<Checkbox value="remember" color="primary" />}
                                        label="Remember me"
                                    />
                                </Grid>
                                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                    <Link href={`/forgot-password?email=${username}`} variant="body2">
                                        Forgot password?
                                    </Link>
                                </Grid>
                            </Grid>
                            <Button
                                text={'Login'}
                                version={'secondary'}
                                action={() => { }}
                                styles={{
                                    width: "100%",
                                    justifyContent: 'center',
                                    marginTop: 15
                                }}
                            />
                        </>
                    }
                </form>
            </Grid>
        </Container>
    );
}

export default Login
